export default "__VITE_ASSET__Dt2lfj2q__"